import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {HostingService} from "../hosting.service";
import {User} from '../../../../user/user';
import {filter, first, switchMap} from 'rxjs/operators';
import {Website} from '../../website';
import {Store} from '@ngrx/store';
import * as fromStore from "../../../../store";

@Injectable()
export class HostingResourceUsageResolver implements Resolve<null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const user: User = (route.parent.data && route.parent.data['user']) || (route.parent.parent.data && route.parent.parent.data['user']) || null;
      const hasHostingServices: boolean = user && user.hosting_services;
      if (hasHostingServices) {
        const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
        this._store.select(fromStore.getWebsitesLoaded)
          .pipe(
            filter((loaded: Boolean) => !!loaded),
            switchMap(() => this._store.select(fromStore.getWebsite(websiteId))),
            first()
          )
          .subscribe((website: Website) => {
            if (website.domain_hash) {
              this._hostingService.getHostingResources(websiteId)
                .pipe(filter((response: DbResponse): boolean => !!response),
                first())
                .subscribe((response) => {
                  if (response.success) {
                    resolve(response.data);
                  }
                  else {
                    resolve(null);
                  }
                });
            }
            else {
              resolve(null);
            }
          });
      }
      else {
        resolve(null);
      }
    });
  }

}
